import React, { useState, createContext, useContext } from "react"

const AuthContext = createContext(null)

export const ProtectedRoute = ({children}) => {

    const [user, setUser] = useState(null)
    const [employeePhoto, setEmployeePhoto] = useState(null)

    const login = user => {
        setUser(user)
    }

    const photo = employeePhoto => {
        setEmployeePhoto(employeePhoto)
    }

    const logout = () => {
        setEmployeePhoto(null)
        setUser(null)
    }

    return <AuthContext.Provider value={{ user, employeePhoto, login, photo, logout }}>
        { children }
        </AuthContext.Provider>
}

export const useAuth = () => {
    return useContext(AuthContext)
};